const initialState = {
   offerList : {},
   offerMetrics : {}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_OFFER_LIST':
        return {
          ...state,
          offerList: action.data,
        }
        case 'SET_OFFER_METRICS':
            return {
              ...state,
              offerMetrics: action.data,
            }
      default:
        return state
    }
  }
  